import React, { useState } from "react";
import "../app.css";
import "../layout/modern_sidebar.css";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Home from "../pages/home";
import { ModernSidebar, TopBar } from "../layout";
import { Layout } from "antd";
import withUser from "../hooks/with_auth";
import paths from "./paths";
import SalePage from "../pages/sales";
import AppoinmentPage from "../pages/appointments";
import ProudctPage from "../pages/products";
import ServicePage from "../pages/services";
import TherapistPage from "../pages/therapists";
import CheckInPage from "../pages/check_in_out";
import ServicePackagePage from "../pages/service_packages";
import ServiceStockItemPage from "../pages/service_stock_items";
import ServiceStockItemUsagePage from "../pages/service_stock_item_usages";
import ProductStockItemPage from "../pages/product_stock_items";
import DailySaleReport from "../pages/reports/daily_sale_report";
import DailySaleDetailReport from "../pages/reports/daily_sale_detail_report";
import CreditReceivedReport from "../pages/reports/credit_received_report";
import TherapistSaleReport from "../pages/reports/therapist_sale_report";
import MemberPage from "../pages/member/members";
import OfferCategoryPage from "../pages/offer/offer_category";
import OfferPage from "../pages/offer/offers";
import MemberDetail from "../pages/member/member_detail";
import NotificationPage from "../pages/notifications";
import TherapistLeavePage from "../pages/therapist_leaves";
import ServiceDetailPage from "../pages/service_detail/service_detail";
import MemberImport from "../pages/member/member_import";
import ClinicDetail from "../pages/clinic_detail";
import BankPage from "../pages/tool/banks";
import NewSalePage from "../pages/newsale";
import NewCheckout from "../pages/new_checkout";
import CheckInDetail from "../pages/checkin_detail";
import ServiceRoomPage from "../pages/service_rooms";
import ServiceRoomDetail from "../pages/service_room_detail";
import SaleDetailPage from "../pages/sale_detail";
import WalletPage from "../pages/wallet/accounts";
import TranscationPage from "../pages/wallet/transactions";
import ServiceTypeCategoryPage from "../pages/service_type_categories";
import TherapistsDetail from "../pages/therapists_detail";
import TreatmentReport from "../pages/reports/treatment_report";
import TopTreatmentReport from "../pages/reports/top_treatment_report";
import TopPractitionerReport from "../pages/reports/top_practitioner_report";
import TopMemberReport from "../pages/reports/top_member_report";
import Helper from "../pages/helper";
import User from "../pages/user/users";
import ServiceConsentFormPage from "../pages/service_form/consent_forms";
import ServiceRecordFormPage from "../pages/service_form/record_forms";
import ServiceBehaviorReport from "../pages/reports/service_behavior_report";
import AIChat from "../ai-chat/chat";
import SellerReport from "../pages/reports/seller_report";
import SaleChannelPage from "../pages/sale_channel/sale_channels";
import SystemLogPage from "../pages/logs";
import GtgramSalePage from "../pages/gtgram_sales";
import SalesBySalesPerson from "../pages/reports/sales_by_sales_person";
import PaymentReportPage from "../pages/reports/payment_report";
import CustomersBySalesPersonPage from "../pages/reports/customers_by_salesperson";
import GeneralSettings from "../pages/settings/general_settings";
import SecuritySettings from "../pages/settings/security_settings";
import NotificationSettings from "../pages/settings/notification_settings";
import Documentation from "../pages/help/documentation";
import FAQ from "../pages/help/faq";
import ContactSupport from "../pages/help/contact_support";
import Analytics from "../pages/analytics/analytics";
import BackupRestore from "../pages/backup/backup_restore";
import SystemInfo from "../pages/system/system_info";
import InventoryReport from "../pages/inventory/inventory_report";
import StockSummary from "../pages/inventory/stock_summary";
import InventoryHistory from "../pages/inventory/inventory_history";

const { Header, Content, Footer } = Layout;
function PRoutes(props: any) {
  // console.log(props, "user props");
  const Navigate = useNavigate();
  const location = useLocation();
  const currentMenuItem =
    location && location.pathname ? location.pathname : paths.home;
  return (
    <div className="App">
      <Layout className="root-layout" hasSider>
        {currentMenuItem !== paths.aichat && (
          <ModernSidebar
            onMenuClick={(val: any) => {
              Navigate(`${val.key}`);
            }}
            currentMenuItem={currentMenuItem}
          />
        )}
        <Layout className="main-layout">
          <Header className="main-header">
            <TopBar />
          </Header>
          <Content className="main-content">
            <div className="content-container">
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path={paths.home} element={<Home />} />
              <Route path={paths.sales} element={<SalePage />} />
              <Route path={paths.salesBySalesPerson} element={<SalesBySalesPerson />} />
              <Route path={paths.paymentReport} element={<PaymentReportPage />} />
              <Route path={paths.customersBySalesPerson} element={<CustomersBySalesPersonPage />} />
              <Route path={paths.appointments} element={<AppoinmentPage />} />
              <Route path={paths.checkIns} element={<CheckInPage />} />
              <Route path={paths.services} element={<ServicePage />} />
              <Route
                path={paths.service_detail}
                element={<ServiceDetailPage />}
              />
              <Route
                path={paths.service_packages}
                element={<ServicePackagePage />}
              />
              <Route path={paths.products} element={<ProudctPage />} />
              <Route path={paths.therapists} element={<TherapistPage />} />
              <Route
                path={paths.therapist_detail}
                element={<TherapistsDetail />}
              />
              <Route path={paths.leaves} element={<TherapistLeavePage />} />
              <Route path={paths.report} element={<DailySaleReport />} />
              <Route
                path={paths.treatment_report}
                element={<TreatmentReport />}
              />
              <Route
                path={paths.practitioner_treatment_report}
                element={<TreatmentReport />}
              />
              <Route
                path={paths.top_treatment_report}
                element={<TopTreatmentReport />}
              />
              <Route
                path={paths.top_treatment_report}
                element={<TopTreatmentReport />}
              />
              <Route
                path={paths.top_practitioner_report}
                element={<TopPractitionerReport />}
              />
              <Route
                path={paths.top_member_report}
                element={<TopMemberReport />}
              />
              <Route path={paths.seller_report} element={<SellerReport />} />
              <Route
                path={paths.credit_received_report}
                element={<CreditReceivedReport />}
              />
              <Route path={paths.seller_sales} element={<SalePage />} />
              <Route path={paths.daily_sales} element={<DailySaleDetailReport />} />
              <Route
                path={paths.therapist_sales}
                element={<TherapistSaleReport />}
              />
              <Route
                path={paths.product_stock_items}
                element={<ProductStockItemPage />}
              />
              <Route
                path={paths.service_stock_items}
                element={<ServiceStockItemPage />}
              />
              <Route path={paths.helper} element={<Helper />} />
              <Route
                path={paths.service_stock_usages}
                element={<ServiceStockItemUsagePage />}
              />
              <Route path={paths.members} element={<MemberPage />} />
              <Route path={paths.offers} element={<OfferPage />} />
              <Route
                path={paths.offer_categories}
                element={<OfferCategoryPage />}
              />
              <Route path={paths.member_detail} element={<MemberDetail />} />
              <Route
                path={paths.notifications}
                element={<NotificationPage />}
              />
              <Route path={paths.memberImport} element={<MemberImport />} />
              <Route path={paths.clinic} element={<ClinicDetail />} />
              <Route path={paths.banks} element={<BankPage />} />
              <Route path={paths.newSale} element={<NewSalePage />} />
              <Route path={paths.newCheckout} element={<NewCheckout />} />
              <Route path={paths.checkIn} element={<CheckInDetail />} />
              <Route path={paths.serviceRooms} element={<ServiceRoomPage />} />
              <Route
                path={paths.serviceRoomDetail}
                element={<ServiceRoomDetail />}
              />
              <Route path={paths.saleDetail} element={<SaleDetailPage />} />
              <Route path={paths.wallets} element={<WalletPage />} />
              <Route path={paths.transactions} element={<TranscationPage />} />
              <Route
                path={paths.service_categories}
                element={<ServiceTypeCategoryPage />}
              />
              <Route path={paths.user} element={<User />} />

              <Route
                path={paths.service_consent_froms}
                element={<ServiceConsentFormPage />}
              />
              <Route
                path={paths.service_record_froms}
                element={<ServiceRecordFormPage />}
              />
              {/*
               <Route path={paths.test_p} element={<TestPage />} /> */}
              <Route
                path={paths.serviceBehaviourDashborad}
                element={<ServiceBehaviorReport />}
              />
              <Route path={paths.sale_channel} element={<SaleChannelPage />} />
              <Route path={paths.aichat} element={<AIChat />} />
              <Route path={paths.logs} element={<SystemLogPage />} />
              <Route path={paths.gtgram_sales} element={<GtgramSalePage />} />
              
              {/* Settings Routes */}
              <Route path="/general-settings" element={<GeneralSettings />} />
              <Route path="/security-settings" element={<SecuritySettings />} />
              <Route path="/notification-settings" element={<NotificationSettings />} />
              
              {/* Help Routes */}
              <Route path="/documentation" element={<Documentation />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact-support" element={<ContactSupport />} />
              
              {/* Analytics Routes */}
              <Route path="/analytics" element={<Analytics />} />
              
              {/* Backup Routes */}
              <Route path="/backup" element={<BackupRestore />} />
              
              {/* System Routes */}
              <Route path="/system" element={<SystemInfo />} />
              
              {/* Inventory Routes */}
              <Route path="/inventory-report" element={<InventoryReport />} />
              <Route path="/stock-summary" element={<StockSummary />} />
              <Route path="/inventory-history" element={<InventoryHistory />} />
            </Routes>
            </div>
          </Content>
          {currentMenuItem !== paths.aichat && (
            <Footer style={{ padding: "20px 0" }}>
              <span>&copy; {new Date().getFullYear()} Greate Time</span>
            </Footer>
          )}
        </Layout>
      </Layout>
    </div>
  );
}
export default withUser(PRoutes);
// export default PRoutes;
